// This is a slider component, with option to input values.
// Used in many chart control options

import { Slider, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import './SliderWithInput.css';

const SliderWithInput = ({
  sliderValue,
  sliderMinMax,
  changeValue,
  percent,
  degree,
  pointNumbers,
}: {
  sliderValue: number;
  sliderMinMax: { min: number; max: number; step: number };
  changeValue: (value: any) => void;
  percent?: boolean;
  degree?: boolean;
  pointNumbers?: boolean;
}) => {
  const [showInputText, setShowInputText] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState(sliderValue || 0);
  const unit = percent ? '%' : degree ? '&#176' : pointNumbers ? '' : 'px';

  return (
    <div className="sliderWithInput">
      {showInputText ? (
        <Tooltip
          title={
            sliderMinMax?.min > inputValue
              ? `Min allowed value is ${sliderMinMax.min} ${unit}`
              : sliderMinMax?.max < inputValue
                ? `Max allowed value is ${sliderMinMax.max} ${unit}`
                : ''
          }
          arrow
          disableHoverListener={inputValue < sliderMinMax.max && inputValue > sliderMinMax.min}
          open={sliderMinMax?.min > inputValue || sliderMinMax?.max < inputValue}
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <form
            style={{ width: '50px', marginRight: '10px' }}
            onSubmit={(evt: any) => {
              evt.currentTarget.querySelector('input').blur();
              evt.preventDefault();
            }}
          >
            <input
              autoFocus
              className="inputValue"
              style={{
                outline:
                  sliderMinMax?.min > inputValue || sliderMinMax?.max < inputValue
                    ? '1px solid rgba(235, 55, 55, 1)'
                    : '',
              }}
              type="number"
              value={inputValue}
              onBlur={(e) => {
                setShowInputText(false);
                const val = Number(e.target.value);
                const clamped = Math.min(Math.max(val, sliderMinMax.min), sliderMinMax.max);
                changeValue(clamped);
                setInputValue(clamped);
              }}
              onChange={(e) => {
                const val = Number(e.target.value);
                setInputValue(val);
                if (sliderMinMax?.min <= val && sliderMinMax?.max >= val) changeValue(val);
              }}
              min={sliderMinMax?.min}
              max={sliderMinMax?.max}
            />
          </form>
        </Tooltip>
      ) : (
        <span
          className="textValue"
          onClick={(e) => {
            setInputValue(sliderValue);
            setShowInputText(true);
          }}
          title="Click to edit value"
        >
          {percent ? (
            `${sliderValue} %`
          ) : degree ? (
            <span>{sliderValue} &#176;</span>
          ) : pointNumbers ? (
            <span>{sliderValue}</span>
          ) : (
            `${sliderValue} px`
          )}
        </span>
      )}
      <Slider
        sx={{
          flex: 3,
          height: '5px',
          alignSelf: 'center',
          margin: '0px 10px 0px 2px',
          color: 'rgb(157, 156, 156)',
          '& .MuiSlider-thumb': {
            boxShadow: '0 1px 2px 1px #9c9c9c',
            height: '13px',
            width: '13px',
          },
          '& .MuiSlider-track': {
            color: '#9c9c9c',
          },
          '& .MuiSlider-rail': {
            color: '#c6c6c6',
          },
        }}
        min={sliderMinMax.min}
        max={sliderMinMax.max}
        step={sliderMinMax.step}
        value={sliderValue}
        onChange={(e: any) => {
          changeValue(Number(e.target.value));
        }}
        // title={sliderValue}
      />
    </div>
  );
};

export default SliderWithInput;
{
  /* <input
				// className="inputRange"
				// style={{ backgroundColor: "red", color: "red", fill: "red", background: "red" }}
				type="range"
				min={sliderMinMax.min}
				max={sliderMinMax.max}
				step={sliderMinMax.step}
				value={sliderValue}
				onInput={(e) => {
					changeValue(Number(e.target.value));
				}}
				title={sliderValue}
			/> */
}
